import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { take } from "rxjs/operators";
import * as moment from "moment";
import { saveAsExcelFile, exportExcel } from "src/app/helpers/helpers";
import { UserService } from "src/app/services/user.service";

const MED_LEGAL_NOTICE =
  "Veri Kullanımı ve Hukuki Sorumluluk Uyarısı: Katılımcı verileri yalnızca tanımlanan hizmet kapsamında kullanılabilir. Ticari elektronik ileti onayı bulunmayan kişilerle iletişime geçilmesi halinde doğabilecek hukuki, idari ve cezai sorumluluk ilgili işlemi gerçekleştiren kullanıcı/kuruma aittir";

const MED_STATIC_EARNINGS = [
  { userPhone: "5377021373", usedDate: "3/8/26 13:20", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5385436431", usedDate: "2/28/26 14:30", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5054786842", usedDate: "2/28/26 14:21", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Yok" },
  { userPhone: "5445704568", usedDate: "2/15/26 13:24", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5077838417", usedDate: "4/13/26 16:47", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5326519577", usedDate: "3/29/26 13:38", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5444787364", usedDate: "5/10/26 14:53", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5546928289", usedDate: "5/2/26 16:58", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5549396362", usedDate: "02.05.2026 14:31", ticariIletiOnayi: "Sms Yok - Email Yok - IVR Yok", acikRizaOnayi: "Yok" },
  { userPhone: "5543487169", usedDate: "4/25/26 12:28", ticariIletiOnayi: "Sms Yok - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5537710614", usedDate: "4/18/26 14:10", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5526369830", usedDate: "4/18/26 13:51", ticariIletiOnayi: "Sms Yok - Email Yok - IVR Yok", acikRizaOnayi: "Yok" },
  { userPhone: "5426319830", usedDate: "4/18/26 13:38", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "5346732203", usedDate: "4/17/26 15:39", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Yok" },
  { userPhone: "506 105 3816", usedDate: "Karekod Okutulmamış", ticariIletiOnayi: "Sms Var - Email Var - IVR Var", acikRizaOnayi: "Var" },
  { userPhone: "505 220 8934", usedDate: "Karekod Okutulmamış", ticariIletiOnayi: "Sms Yok - Email Yok - IVR Yok", acikRizaOnayi: "Yok" },
  { userPhone: "506 505 2423", usedDate: "Karekod Okutulmamış", ticariIletiOnayi: "Sms Yok - Email Yok - IVR Yok", acikRizaOnayi: "Yok" },
  { userPhone: "535 248 6256", usedDate: "Karekod Okutulmamış", ticariIletiOnayi: "Sms Yok - Email Yok - IVR Yok", acikRizaOnayi: "Yok" },
  { userPhone: "530 515 0325", usedDate: "Karekod Okutulmamış", ticariIletiOnayi: "Sms Yok - Email Yok - IVR Yok", acikRizaOnayi: "Yok" },
  { userPhone: "544 527 5891", usedDate: "Karekod Okutulmamış", ticariIletiOnayi: "Sms Yok - Email Yok - IVR Yok", acikRizaOnayi: "Yok" }
];

@Component({
  selector: "app-admin-used-earnings",
  templateUrl: "./admin-used-earnings.component.html",
  styleUrls: ["./admin-used-earnings.component.scss"]
})
export class AdminUsedEarningsComponent implements OnInit {
  usedEarnings = [];
  medEarnings = MED_STATIC_EARNINGS;
  medLegalNotice = MED_LEGAL_NOTICE;
  loading = false;
  isMed = false;

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.isMed = this.userService.isMed();
    if (this.isMed) {
      return;
    }
    this.loading = true;
    this.http
      .get("/getAdminUsedEarnings")
      .pipe(take(1))
      .subscribe((res: any) => {
        this.usedEarnings = res || [];
        this.loading = false;
      });
  }

  downloadExcel() {
    if (this.isMed) {
      this.downloadMedExcel();
      return;
    }

    const output = this.usedEarnings.map((item) => ({
      Kod: item.discountCode,
      "Kullanım Tarihi": item.usedDate
        ? moment(item.usedDate).format("DD.MM.YYYY HH:mm")
        : "",
      "Kullanıcı Telefonu": item.userPhone
    }));
    exportExcel(output, "kullanilmis-kazanimlar");
  }

  private downloadMedExcel() {
    const rows = this.medEarnings.map((item) => ({
      "Kullanıcı Telefonu": item.userPhone,
      "Kullanım Tarihi": item.usedDate,
      "Ticari İleti Onayı": item.ticariIletiOnayi,
      "Açık Rıza Onayı": item.acikRizaOnayi
    }));

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(rows);
      const noticeRow = rows.length + 1 + 2;
      xlsx.utils.sheet_add_aoa(worksheet, [[MED_LEGAL_NOTICE]], {
        origin: `A${noticeRow}`
      });
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      saveAsExcelFile(excelBuffer, "kullanilmis-kazanimlar");
    });
  }
}
